// extracted by css-extract-rspack-plugin
export default {"watcher":"SearchPopup-watcher_NeO"};